import React from 'react';
import SidebarButton from './SidebarButton';

import { ReactComponent as AttachFileOutlined } from '../../../assets/sidepanel/attachments.svg';
import { ReactComponent as BookmarksOutlined } from '../../../assets/sidepanel/bookmarks.svg';
import { ReactComponent as CommentOutlined } from '../../../assets/sidepanel/annotations.svg';
import { ReactComponent as CompareOutlined } from '../../../assets/sidepanel/compare.svg';
import { ReactComponent as LayersOutlined } from '../../../assets/sidepanel/layers.svg';
import { ReactComponent as PropertiesOutlined } from '../../../assets/sidepanel/properties.svg';
import { ReactComponent as SearchOutlined } from '../../../assets/sidepanel/search.svg';
import { ReactComponent as SignatureOutlined } from '../../../assets/sidepanel/file-sign.svg';
import { ReactComponent as ThumbnailsOutlined } from '../../../assets/sidepanel/thumbnails.svg';
import { useSelector } from 'react-redux';
import {
    eplassSliceAnnotationSidepanelRefresh,
    eplassSliceViewMode,
} from '../../../Redux/EplassSlice';
import { PdfViewerViewModeFlag } from '../../../pdf/Enums';
import { ReduxUpdater } from '../../../pdf/ReduxUpdater';

const buttonKeys = [
    'annotations',
    'thumbnails',
    'bookmarks',
    'signatures',
    'layers',
    'attachments',
    'search',
    'properties',
    'compare',
] as const;

const buttonKeysForMode: Partial<Record<PdfViewerViewModeFlag, (typeof buttonKeys)[number][]>> = {
    [PdfViewerViewModeFlag.EmailsAndOffice]: ['thumbnails', 'bookmarks', 'attachments', 'search'],
    [PdfViewerViewModeFlag.Compare]: ['thumbnails', 'search', 'compare'],
    [PdfViewerViewModeFlag.Images]: [],
};

const buttonIcons = {
    annotations: <CommentOutlined />,
    attachments: <AttachFileOutlined />,
    bookmarks: <BookmarksOutlined />,
    compare: <CompareOutlined />,
    layers: <LayersOutlined />,
    properties: <PropertiesOutlined />,
    search: <SearchOutlined />,
    signatures: <SignatureOutlined />,
    thumbnails: <ThumbnailsOutlined />,
};

export default () => {
    const viewMode = useSelector(eplassSliceViewMode);
    const forceRefresh = useSelector(eplassSliceAnnotationSidepanelRefresh);

    const menu = React.useMemo(() => {
        return (
            <>
                {(buttonKeysForMode[viewMode] || buttonKeys).map(key => (
                    <SidebarButton
                        key={key}
                        buttonKey={key}
                        buttonDisabled={
                            [PdfViewerViewModeFlag.Error, PdfViewerViewModeFlag.Loading].includes(
                                viewMode,
                            ) ||
                            (key === 'compare' && ReduxUpdater.documentHistory.length === 0)
                        }
                        icon={buttonIcons[key]}
                    />
                ))}
            </>
        );
    }, [forceRefresh, viewMode]);

    return menu;
};
